import { c as _c } from "react/compiler-runtime";
import { Heading, Stack, Text, VStack, Avatar, Spacer } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { Benefit } from '@src/graphql-types';
type PartnerProfileHeroProps = {
  benefit: Benefit;
};
export const PartnerProfileHero = props => {
  const $ = _c(45);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t0 = `linear-gradient({colors.colorPalette.container/90}, {colors.colorPalette.container/90}), url(${props.benefit.heroImage?.url})`;
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([5, 5, 20]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue(["200px", "200px", "400px"]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== getBreakpointValue) {
    t3 = getBreakpointValue([5, 5, 20]);
    $[4] = getBreakpointValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== getBreakpointValue) {
    t4 = getBreakpointValue(["column", "column", "row"]);
    $[6] = getBreakpointValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== getBreakpointValue) {
    t5 = getBreakpointValue([5, 5, 8]);
    $[8] = getBreakpointValue;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== getBreakpointValue) {
    t6 = getBreakpointValue(["lg", "xl", "2xl"]);
    $[10] = getBreakpointValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props.benefit.name) {
    t7 = <Avatar.Fallback name={props.benefit.name} />;
    $[12] = props.benefit.name;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = props.benefit.logoImage?.url;
  let t9;
  if ($[14] !== t8) {
    t9 = <Avatar.Image src={t8} />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t9) {
    t10 = <Avatar.Root size={t6}>{t7}{t9}</Avatar.Root>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== getBreakpointValue) {
    t11 = getBreakpointValue(["3xl", "4xl", "5xl"]);
    $[20] = getBreakpointValue;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== props.benefit.name || $[23] !== t11) {
    t12 = <Heading size={t11}>{props.benefit.name}</Heading>;
    $[22] = props.benefit.name;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== getBreakpointValue) {
    t13 = getBreakpointValue(["md", "lg"]);
    $[25] = getBreakpointValue;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== props.benefit.teaser || $[28] !== t13) {
    t14 = <Text color="colorPalette.fg/75" fontSize={t13}>{props.benefit.teaser}</Text>;
    $[27] = props.benefit.teaser;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Spacer />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t12 || $[32] !== t14) {
    t16 = <VStack align="start" gap={2}>{t12}{t14}{t15}</VStack>;
    $[31] = t12;
    $[32] = t14;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t10 || $[35] !== t16 || $[36] !== t4 || $[37] !== t5) {
    t17 = <VStack align="flex-start" gap={5} maxW="80em" width="full"><Stack align="flex-start" direction={t4} gap={t5} maxWidth="container.sm" width="full">{t10}{t16}</Stack></VStack>;
    $[34] = t10;
    $[35] = t16;
    $[36] = t4;
    $[37] = t5;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t0 || $[40] !== t1 || $[41] !== t17 || $[42] !== t2 || $[43] !== t3) {
    t18 = <Stack align="center" backgroundImage={t0} backgroundPosition="center" backgroundRepeat="no-repeat" backgroundSize="cover" boxShadow="inset 0px -20px 10px -20px rgba(0, 0, 0, 0.15)" direction="row" gap={t1} justify="center" minHeight={t2} padding={t3} width="full">{t17}</Stack>;
    $[39] = t0;
    $[40] = t1;
    $[41] = t17;
    $[42] = t2;
    $[43] = t3;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};
{
  /* <Box>{props.benefit.name}</Box> */
}